// extracted by mini-css-extract-plugin
export default {"title":"addcourses_title__c2F4r","inputform":"addcourses_inputform__KvEal"};